// APIComingSoon.jsx - API Documentation coming soon page
import React from 'react';
import ComingSoon from './ComingSoon';
import { Code2 } from 'lucide-react';

export default function APIComingSoon() {
  return (
    <ComingSoon 
      title="API Documentation" 
      description="Comprehensive API guides, SDKs, and integration examples are coming soon. Build powerful integrations with CodeRated's AI analysis engine."
      icon={Code2}
      showNotify={true}
    />
  );
}

// This component can be used in your router like:
// <Route path="/api-docs" element={<APIComingSoon />} />